import Config from "src/Constants/Config";
import CustomCenterContent from "src/Pages/CustomCenterContent";
import ImageMEF from "src/Component/ImageMEF";

const PageId = 5;

const DATA = () => {
  return {
    showHeader: true,
    bgVideo: {
      video: `${Config.BASE_URL}/videos/mef.mp4`,
      poster: `${Config.BASE_URL}/images/bg_2.jpg`,
    },
    children: (
      <CustomCenterContent pageId={PageId}>
        <ImageMEF src={`${Config.BASE_URL}/images/mef_5.jpg`} />
      </CustomCenterContent>
    ),
  };
};

export default DATA;
